import React, { Component } from 'react'
import './gallery.scss' 
import Accordion from './accorion'
import GallerySlider from './gallery-slider'

const data = [
  {
    id: 1,
    title: 'уникальные виды',
    subtitle: 'Прекрасный вид',
    text: `Высота восточного крыла достигает рекордных 374 метров. 
          На высоту жителей и гостей комплекса «Федерация» доставляют 
          67 самых современных лифтов.`
  },
  {
    id: 2,
    title: 'Панорамные окна',
    subtitle: 'Настоящие панорамы',
    text: `Высота восточного крыла достигает рекордных 374 метров. 
          На высоту жителей и гостей комплекса «Федерация» доставляют 
          67 самых современных лифтов.`
  },
  {
    id: 3,
    title: 'высокие потолки',
    subtitle: 'Простор для идей',
    text: `Высота восточного крыла достигает рекордных 374 метров. 
          На высоту жителей и гостей комплекса «Федерация» доставляют 
          67 самых современных лифтов.`
  },
  {
    id: 4,
    title: 'ПРИВАТНОСТЬ',
    subtitle: 'VIP-безопасность',
    text: `Высота восточного крыла достигает рекордных 374 метров. 
           На высоту жителей и гостей комплекса «Федерация» доставляют 
           67 самых современных лифтов.`
  },
  // {
  //   id: 5,
  //   title: 'Настоящие панорамы',
  //   subtitle: 'Панорамные окна',
  //   text: `Высота восточного крыла достигает рекордных 374 метров. 
  //          На высоту жителей и гостей комплекса «Федерация» доставляют 
  //          67 самых современных лифтов.`
  // },
  // {
  //   id: 6,
  //   title: 'Настоящие панорамы',
  //   subtitle: 'Панорамные окна',
  //   text: `Высота восточного крыла достигает рекордных 374 метров. 
  //          На высоту жителей и гостей комплекса «Федерация» доставляют 
  //          67 самых современных лифтов.`
  // }
]


class Gallery extends Component {
  state = {
    width: window.innerWidth
  }

  render() {
    return (
      this.state.width < 768 ? <GallerySlider data={data} /> : <Accordion data={data} />
    )
  }

  updateWidth = () => {
    this.setState({
      width: window.innerWidth
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateWidth);
  }
}

export default Gallery